<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">项目管理</div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Row>
                <Col
                  :xs="{ span: 24 }"
                  :lg="{ span: 12 }"
                  style="margin: 5px 0"
                >
                  <Button
                    type="primary"
                    icon="md-add"
                    v-if="$store.state.auth == 1"
                    @click="addClick"
                    style="margin-right: 10px"
                    >新增</Button
                  >
                </Col>
                <Col
                  :xs="{ span: 24 }"
                  :lg="{ span: 12 }"
                  style="margin: 5px 0"
                >
                  <Input v-model="searchValue" placeholder="搜索">
                    <Select
                      v-model="searchType"
                      slot="prepend"
                      style="width: 120px"
                    >
                      <Option :value="1">项目名称</Option>
                      <Option :value="2">项目APPID</Option>
                    </Select>
                    <Button
                      slot="append"
                      icon="ios-search"
                      @click="_getData"
                    ></Button>
                  </Input>
                </Col>
              </Row>
            </div>
            <div v-if="data.length == 0">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Row :gutter="24">
                <Col
                  :xxl="6"
                  :xl="8"
                  :lg="8"
                  :md="12"
                  :sm="24"
                  :xs="24"
                  class="ivu-mb"
                  v-for="item in data"
                  :key="item.id"
                >
                  <Card class="list-goods-list-item">
                    <div class="name">
                      {{ item.name }}
                      <Tag
                        color="orange"
                        style="float: right; font-weight: 100"
                      >
                        {{ item.version }}</Tag
                      >
                    </div>
                    <div class="explain">最后更新：{{ item.time }}</div>
                    <div class="explain">
                      APPID：
                      {{ item.appid }}
                    </div>
                    <div class="price">
                      <em style="font-size: 12px">￥</em>{{ item.advise_price }}
                      <span class="old">最低零售价</span>
                    </div>
                    <div class="btn" v-if="$store.state.auth == 1">
                      <Button
                        type="primary"
                        size="small"
                        style="margin-right: 5px"
                        @click="editClick(item)"
                        >编辑</Button
                      >
                      <Button type="error" size="small" @click="del(item.id)"
                        >删除</Button
                      >
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
import { getProject, delProject } from "@/api";

export default {
  data() {
    return {
      searchValue: "",
      searchType: 1,
      loading: false,
      data: [],
    };
  },
  created() {
    this._getData();
  },
  watch: {
    searchValue(newVal, oldVal) {
      if (newVal == "") {
        this._getData();
      }
    },
  },
  methods: {
    // 获取列表
    _getData() {
      getProject({
        name: this.searchType == 1 ? this.searchValue : "",
        appid: this.searchType == 2 ? this.searchValue : "",
      }).then((res) => {
        this.data = res.data;
      });
    },
    // 删除
    del(id) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "删除后无法恢复，是否继续？",
        onOk: () => {
          this.delFunction(id);
        },
      });
    },

    // 删除方法
    delFunction(id) {
      this.loading = true;
      delProject({
        id: id,
      }).then((res) => {
        if (res.code == 200) {
          this.$Message.success({
            background: true,
            content: res.msg,
          });
          this._getData();
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
        this.loading = false;

        this.Selection = [];
      });
    },

    //  新增按钮
    addClick() {
      this.$router.push("/admin/project/edit");
    },

    //  编辑按钮
    editClick(row) {
      this.$router.push("/admin/project/edit?id=" + row.id);
    },

    // 分页跳转
    pageChange(val) {
      this.pageIndex = val;
      this._getData();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this._getData();
    },
  },
};
</script>

<style lang="less" scoped>
.list-goods-list-item {
  .name {
    font-size: 16px;
    font-weight: 600;
    color: red;

    span {
      float: right;
      color: #000000;
    }
  }

  .price {
    font-size: 20px;
    color: red;

    .old {
      font-size: 16px;
      color: #ccc;
    }
  }

  .btn {
    text-align: right;
  }

  .explain {
    font-size: 14px;
    color: #000000;
    margin: 5px 0;
  }
}
</style>